import React, { Component } from "react";
import "./CarModel.css";
import { Link } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Car from "../Car/Car";
import { fetchModelo } from "../../actions/cars";
import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";
import { isMobile } from "react-device-detect";

import store from "../../store";

const api = process.env.REACT_APP_API;
const imgdir = process.env.REACT_APP_IMG_FOLDER;

class carModel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cars: []
    };
  }

  componentDidMount() {
    this.getCars();
  }

  getCars = () => {
    this.fetchCars()
      .then(res => this.setState({ cars: res }))
      .catch(err => console.log(err));
  };

  fetchCars = async () => {
    const response = await fetch(api + "autos/" + this.props.name);
    const res = await response.json();

    if (response.status !== 200) {
      throw Error(response.message);
    }

    console.log(res);
    return res;
  };

  render() {
    return isMobile ? (
      <React.Fragment>
        <Grid container style={{ textAlign: "left", marginTop: "5px" }}>
          <Grid item xs={12} className="CarModelTitleDiv">
            <div className="CarModelTitle">
              <img
                src={imgdir + "logos/" + this.props.name.toLowerCase() + ".png"}
                className="CarLogoImg"
              />
            </div>
          </Grid>

          {this.state.cars.map(car => (
            <Grid item xs={12} sm={isMobile ? 12 : 3}>
              <Car
                modelName={car.modelo}
                version={car.version}
                price={"$" + car.precio}
                image={car.foto0}
                version2={car.version}
                motor={car.motor}
                tipo={car.tipo}
                color={car.color}
                year={car.anio}
                gear={car.transmision}
                chasis={car.vin}
                car={car}
              />
            </Grid>
          ))}
        </Grid>
      </React.Fragment>
    ) : (
      <React.Fragment>
        <div container style={{ textAlign: "left", marginTop: "5px" }}>
          <Grid item xs={12} className="CarModelTitleDiv">
            <img
              src={imgdir + "logos/" + this.props.name.toLowerCase() + ".png"}
              className="CarLogoImg"
            />
          </Grid>
          <div className="GridRoot">
            <GridList className="GridList" cols={isMobile ? 1 : 4.5}>
              {this.state.cars.map(car => (
                <GridListTile key={car.vin} className="GridListTileCar">
                  <Car
                    modelName={car.modelo}
                    version={car.version}
                    price={"$" + car.precio}
                    image={car.foto0}
                    version2={car.version}
                    motor={car.motor}
                    tipo={car.tipo}
                    color={car.color}
                    year={car.anio}
                    gear={car.transmision}
                    chasis={car.vin}
                    car={car}
                  />
                </GridListTile>
              ))}
              ))}
            </GridList>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default carModel;
